import * as React from "react";
import { memo } from "react";

import { LoadingPage } from "@hl/base-components/lib/LoadingPage";
import {
  FEATURE_FLAGS,
  useFeatureFlags,
} from "@hl/shared-features/lib/features/auth/hooks";
import { NotFound } from "@hl/shared-features/lib/features/layout";
import loadable from "@loadable/component";
import { useParams } from "react-router-dom";

import { TOOLS_URL } from "~config";

import { useGetCollectionByOnChainIdQuery } from "./queries.graphql.generated";

import MintPage from "./index";
const MintPageApollo = loadable(
  () => import("../../features/MintPage/MintPageApollo")
);
const MintPageByOnChainId = ({ isApollo }: { isApollo?: boolean }) => {
  const { onChainId } = useParams();
  const apolloMintPageUpdate = useFeatureFlags(
    FEATURE_FLAGS.APOLLO_MINT_PAGE_UPDATE
  );
  const { data, loading } = useGetCollectionByOnChainIdQuery({
    variables: {
      onChainId: onChainId ?? "",
    },
  });
  if (loading) {
    return <LoadingPage />;
  }
  if (!data) {
    return <NotFound redirectUrl={TOOLS_URL.base} />;
  }
  const collectionId = data.getCollectionByOnChainId.id;
  return apolloMintPageUpdate || isApollo ? (
    <MintPageApollo collectionId={collectionId} />
  ) : (
    <MintPage collectionId={collectionId} />
  );
};

export default memo(MintPageByOnChainId);
